export enum DistributorSearchEnums {
    By_Member = 1,
    By_Name = 2,
    By_OrderId = 3,
    By_CardNumber = 4
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/distributor-search.enum.ts